import React from "react";
import Tabs from '../tabs'

export default function PackageTabs({ tabsOptions, tabContent }) {
    return (
        <Tabs tabsOptions={tabsOptions} tabContent={tabContent} />
    )
}